module.exports = __webpack_public_path__ + "img/ar.1b145e05.svg";